import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'redux-router';
import { Link } from 'react-router';
import shallowEqual from 'react-pure-render/shallowEqual';
import has from 'lodash/has';
import findIndex from 'lodash/findIndex';

import { setHeader, loadScheduleView } from 'actions';

import Icon from 'components/common/Icon';
import Loading from 'components/common/Loading';
import EventList from 'components/calendar/EventList';
import EventListItem from 'components/calendar/EventListItem';

class ScheduleViewPage extends Component {
  static loadData(props) {
    const { schedule_id } = props;

    props.loadScheduleView(schedule_id);
  }

  constructor(props) {
    super(props);

    this.renderEventListItem = this.renderEventListItem.bind(this);
  }

  componentWillMount() {
    ScheduleViewPage.loadData(this.props);
    this.updateHeader(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.schedule_id && nextProps.schedule_id !== this.props.schedule_id) {
      ScheduleViewPage.loadData(nextProps);
    }

    const currentEvents = has(this.props, 'schedule_events') ? this.props.schedule_events : [];
    const scheduleChanged = (has(nextProps, 'schedule_events') && !shallowEqual(nextProps.schedule_events, currentEvents));

    if (scheduleChanged) {
      this.updateHeader(nextProps);
    }
  }

  updateHeader(props) {
    if(has(props, 'schedule_details.name')) {
      const schedule_details = props.schedule_details;

      props.setHeader(schedule_details.name, '/schedule', 'Schedules');
    } else {
      props.setHeader('Schedule', '/schedule', 'Schedules');
    }
  }

  renderEventListItem(event, drawDivider = false) {
    return (
      <EventListItem
        drawDivider={drawDivider}
        showChevron
        event={event}
        key={`${event.date}_${event.id}`}
        onSelect={selectedEvent => this.props.push(`/calendar/details/${selectedEvent.id}`)}
      />
   );
  }

  render() {
    const { schedule_id, schedule_details, schedule_events, isLoading } = this.props;

    if (isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    return (
      <section className="inbox-page">
        <EventList
          events={schedule_events}
          isLoading={isLoading}
          renderItem={this.renderEventListItem}
        />
      </section>
    );
  }
}

function mapStateToProps(state) {
  const { schedule_id } = state.router.params;
  const { schedule } = state;
  const { schedule_details, schedule_events } = schedule;

  const isLoading = !has(schedule_details, 'id') && !has(schedule_details, 'isError');

  return {
    schedule_id,
    schedule_details,
    schedule_events,
    isLoading,
  };
}

export default connect(mapStateToProps, {
  setHeader,
  loadScheduleView,
  push,
})(ScheduleViewPage);



// WEBPACK FOOTER //
// ./src/app/containers/ScheduleViewPage.js